// componente che contiene tutti i metodi utilizzati per gestire i pannelli; queste funzioni sono richiamate esternamente
// dalle altre componenti che costituiscono tutto il blocco di gestione pannelli (body-edit e body-list)

import { Injectable } from '@angular/core';
import { Body } from './body.model';
import { Subject } from 'rxjs';

@Injectable()
export class BodyService {
  private body: Body[] = [];
  bodyChanged = new Subject<Body[]>();
  bodyEditMode = new Subject<number>();

  constructor(
  ) { }

  // metodo richiamato alla modifica di un pannello; viene identificata la posizione nella tabella dell'elemento da aggiornare
  editBody(bodyId: number) {
    this.bodyEditMode.next(bodyId);
  }

  // metodo richiamato all'inserimento di un nuovo pannello; viene identificata la posizione nella tabella dell'elemento da aggiungere
  setBody(body: Body[]) {
    if (body !== null) {
      this.body = body;
      this.bodyChanged.next(this.body.slice());
    }
  }

  // metodo che restituisce l'intero oggetto "pannello" in base alla posizione nella tabella
  getBodyByIndex(id: number) {
    return this.body.find(x => x.id === id);
  }

  // metodo che restituisce tutti i pannelli memorizzati localmente
  getBody() {
    return this.body;
  }

  // metodo che inserisce il nuovo pannello appena inserito nell'array locale contenente tutti i pannelli, aggiornando la tabella
  addBody(body: Body) {
    body.id = this.body.length + 1;
    this.body.push(body);
    this.bodyChanged.next(this.body.slice());
  }

  // metodo che aggiorna il pannello appena modificato nell'array locale contenente tutti i pannelli, aggiornando la tabella
  updateBody(index: number, body: Body) {
    this.body[index] = body;
    this.bodyChanged.next(this.body.slice());
  }

  // metodo che individua la posizione del pannello appena cancellato, aggiorna la tabella e l'array locale contenente tutti i pannelli
  deleteBody(id) {
    var elementPos = this.body.map(function (x) { return x.id; }).indexOf(id);
    this.body.splice(elementPos, 1);
    this.bodyChanged.next(this.body.slice());
  }
}
